import * as z from 'zod';

export const leaveCategoryFormSchema = z.object({
  Title: z.string().min(1, { message: 'TITLE_REQUIRED' }),
  LeaveLimit: z.coerce.number().min(0, { message: 'LEAVE_LIMIT_MUST_BE_POSITIVE' }),
  IsUnlimited: z.boolean().default(false),
});

export type LeaveCategoryFormValues = z.infer<typeof leaveCategoryFormSchema>;
